<template>
  <!-- Tela cheia: o mesmo conteúdo passa a ser renderizado dentro de um v-dialog fullscreen. -->
  <component :is="fullscreen ? 'v-dialog' : 'div'" v-bind="wrapperAttrs" v-on="wrapperListeners">
  <div
    class="unidade-comparacao-rotas d-flex flex-column pa-2"
    :class="{ 'unidade-comparacao-rotas--fullscreen white': fullscreen }"
  >
    <template v-if="!unidade || unidade.id_unidade == null">
      <v-alert type="info" dense outlined>{{ $t('crudLinhas.detail.selectResource') }}</v-alert>
    </template>
    <template v-else>
      <div class="d-flex align-center flex-wrap mb-2 flex-grow-0">
        <!-- O painel de unidade não tem seletor de sentido no topo: a comparação tem o seu. -->
        <v-select
          v-model="sentidoLocal"
          :items="sentidosComparaveis"
          item-text="descricao_sentido"
          item-value="id_sentido"
          :label="t('direction')"
          class="unidade-comparacao-rotas__sentido mr-4"
          dense
          outlined
          hide-details
        />
        <v-select
          v-model="tipoOtimizacao"
          :items="tiposOtimizacao"
          :label="t('optimizationType')"
          class="unidade-comparacao-rotas__sentido mr-4"
          dense
          outlined
          hide-details
        />
        <v-spacer />
        <v-btn small text color="primary" class="mr-2" :disabled="loading" @click="load">
          <v-icon left small>mdi-refresh</v-icon>
          {{ t('refresh') }}
        </v-btn>
        <v-btn v-if="podeVerHistorico" small text color="primary" class="mr-2" @click="abreHistorico">
          <v-icon left small>mdi-history</v-icon>
          {{ t('history') }}
        </v-btn>
        <v-btn
          v-if="!porLinha"
          small
          :text="!sobrepor"
          :outlined="sobrepor"
          color="primary"
          class="mr-2"
          @click="sobrepor = !sobrepor"
        >
          <v-icon left small>{{ sobrepor ? 'mdi-view-column' : 'mdi-layers-outline' }}</v-icon>
          {{ sobrepor ? t('sideBySide') : t('overlay') }}
        </v-btn>
        <v-btn
          v-if="canEdit"
          small
          color="primary"
          :loading="gerando"
          :disabled="gerando"
          @click="gerarOtimizacao"
        >
          <v-icon left small>mdi-map-marker-path</v-icon>
          {{ t('generate') }}
        </v-btn>
        <v-btn
          small
          icon
          class="ml-2"
          :title="fullscreen ? t('exitFullscreen') : t('fullscreen')"
          @click="fullscreen = !fullscreen"
        >
          <v-icon>{{ fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
        </v-btn>
      </div>
      <v-alert v-if="porLinha && !loading && dados && !linhasUnidade.length" type="info" dense outlined class="flex-grow-0">
        {{ t('noLines') }}
      </v-alert>
      <v-row v-else dense>
        <v-col cols="12">
      <v-alert v-if="gerando" type="info" dense outlined class="flex-grow-0">
        {{ t('generating') }}
      </v-alert>
      <v-progress-linear v-if="loading || loadingRotas" indeterminate color="primary" class="mb-2 flex-grow-0" />

      <!-- Resumo: linhas hoje x rotas da consolidação -->
      <v-card v-if="dados && !porLinha" outlined class="mb-2 flex-grow-0">
        <v-card-text class="pt-1 pb-2">
          <v-row dense>
            <v-col
              v-for="info in resumo"
              :key="info.label"
              cols="6"
              sm="4"
              md
              class="unidade-comparacao-rotas__indicador"
            >
              <div class="body-2 text--secondary">{{ info.label }}</div>
              <div class="title" :class="info.classe">{{ info.valor }}</div>
            </v-col>
          </v-row>
          <div v-for="aviso in avisos" :key="aviso" class="body-2 orange--text text--darken-2 mt-1">{{ aviso }}</div>
        </v-card-text>
      </v-card>

      <v-row dense>
        <v-col v-for="coluna in colunasVisiveis" :key="coluna.key" cols="12" :md="sobrepor ? 12 : 6">
          <v-card outlined class="fill-height d-flex flex-column">
            <v-card-title class="subtitle-1 py-2">{{ coluna.titulo }}</v-card-title>
            <div class="unidade-comparacao-rotas__map" :class="{ 'unidade-comparacao-rotas__map--sobreposto': sobrepor }">
              <l-map
                :ref="'map_' + coluna.key"
                :zoom="11"
                :center="centroPadrao"
                :options="{ zoomControl: true, attributionControl: false, preferCanvas: true }"
                style="height: 100%; width: 100%"
                @ready="onMapaPronto(coluna.key)"
              >
                <l-tile-layer :url="tileUrl" />
                <l-geo-json
                  v-for="geo in coluna.geojsons"
                  :key="coluna.key + '_geo_' + geo.id"
                  :geojson="geo.geojson"
                  :options-style="geo.style"
                />
                <!-- Paradas: desenhadas em canvas por desenhaParadas (milhares de pontos por unidade) -->
                <l-circle-marker
                  v-if="centro"
                  :lat-lng="[centro.lat, centro.lng]"
                  :radius="9"
                  color="#212121"
                  fill-color="#212121"
                  :fill-opacity="1"
                  :weight="2"
                >
                  <l-tooltip>{{ centro.label }}</l-tooltip>
                </l-circle-marker>
              </l-map>
              <v-overlay absolute :value="loading" :opacity="0.15" :z-index="1000">
                <v-progress-circular indeterminate color="primary" />
              </v-overlay>
              <div v-if="!loading && coluna.vazio" class="unidade-comparacao-rotas__vazio text-body-2">
                {{ coluna.vazio }}
              </div>
              <v-card v-if="coluna.camadas" class="unidade-comparacao-rotas__legenda pa-2" elevation="3">
                <div class="caption font-weight-medium mb-1">{{ t('legend') }}</div>
                <v-switch
                  v-for="item in coluna.camadas"
                  :key="item.camada"
                  v-model="camadasSobreposicao[item.camada]"
                  class="mt-0 pt-0"
                  dense
                  inset
                  hide-details
                >
                  <template #label><span class="caption">{{ item.titulo }}</span></template>
                </v-switch>
              </v-card>
            </div>
            <!-- Uma linha (ou rota) por item, com a cor usada no mapa -->
            <merus-data-table
              v-if="coluna.itens.length"
              :headers="cabecalhoTabela(coluna)"
              :items="linhasTabela(coluna)"
              item-key="key"
              flat
              :items-per-page="5"
              disable-tabela-front-config
              class="unidade-comparacao-rotas__tabela"
              :item-class="itemClasseTabela"
              @click:row="selecionaLinhaTabela"
            >
              <template #item.nome="{ item }">
                <span class="unidade-comparacao-rotas__swatch mr-2" :style="{ background: item.cor }" />
                {{ item.nome }}
              </template>
              <template v-for="(h, i) in coluna.cabecalho.slice(1)" #[`item.v${i}`]="{ item }">
                <span :key="i" :class="item.classes && item.classes[i]">{{ item.valores[i] }}</span>
              </template>
            </merus-data-table>
          </v-card>
        </v-col>
      </v-row>
        </v-col>
      </v-row>
    </template>
  </div>
  </component>
</template>

<script>
import L from "leaflet";
import { VDialog } from "vuetify/lib";
import { LMap, LTileLayer, LGeoJson, LCircleMarker, LTooltip } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import MerusDataTable from "@/components/Tables/MerusDataTable.vue";
import { podeVerHistoricoRotasOtimizadas, rotaHistoricoRotasOtimizadas } from "@/utils/historicoRotasOtimizadas";

// Paleta categórica: cada linha atual / rota consolidada ganha uma cor
const PALETA = [
  "#1976D2", "#E65100", "#2E7D32", "#8E24AA", "#C2185B", "#00838F",
  "#5D4037", "#F9A825", "#3949AB", "#7CB342", "#D81B60", "#546E7A",
];
const COR_PARADA = "#455A64";
const COR_NAO_ATENDIDA = "#D50000";
const TIPO_ROTA_DESLOCAMENTO = 2;
const SENTIDO_IDA = 1;
const POLL_MS = 3000;
// Linhas por requisição ao buscar as rotas (geojson) da situação atual
const LINHAS_POR_LOTE_ROTAS = 8;
// O script espera vaga no teto de chamadas ao VROOM por minuto e cada chamada pode levar até 5 min
const POLL_TIMEOUT_MS = 15 * 60 * 1000;
/** PENDING por mais que isso indica que o scheduler não está rodando. */
const PENDING_TIMEOUT_MS = 2 * 60 * 1000;

function toNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Maior lotação entre os turnos da linha; sem lotação por turno, a lotação prevista. */
function lotacaoDaLinha(l) {
  return toNumber(l.lotacao_maxima) || toNumber(l.lotacao_prevista);
}

function cor(i) {
  return PALETA[i % PALETA.length];
}

/** Comprimento em metros das linhas de um GeoJSON (LineString/MultiLineString, Feature ou coleção). */
function comprimentoGeojson(geojson) {
  let total = 0;
  try {
    L.geoJSON(geojson).eachLayer((layer) => {
      if (typeof layer.getLatLngs !== "function") return;
      const partes = layer.getLatLngs();
      const linhas = Array.isArray(partes[0]) ? partes : [partes];
      linhas.forEach((pts) => {
        for (let i = 1; i < pts.length; i++) total += pts[i - 1].distanceTo(pts[i]);
      });
    });
  } catch (_) {
    return 0;
  }
  return total;
}

export default {
  name: "UnidadeComparacaoRotas",
  // VDialog explícito: o vuetify-loader não registra componentes usados só via <component :is>.
  components: { MerusDataTable, VDialog, LMap, LTileLayer, LGeoJson, LCircleMarker, LTooltip },
  props: {
    unidade: { type: Object, default: null },
    sentidos: { type: Array, default: () => [] },
    canEdit: { type: Boolean, default: false },
    /** Aba visível: só carrega/redimensiona os mapas quando o usuário está olhando. */
    active: { type: Boolean, default: false },
  },
  data() {
    return {
      tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      centroPadrao: [-23.55, -46.63],
      sentidoLocal: null,
      /** "unidade": otimização da unidade inteira; "linha": otimização de cada linha atual. */
      tipoOtimizacao: "unidade",
      /** Linha filtrada na comparação linha a linha (null = todas). */
      idLinhaSelecionada: null,
      /** Rota otimizada de cada linha (linha a linha), por id_linha. */
      otimizadasLinha: {},
      loading: false,
      loadingRotas: false,
      dados: null,
      carregadoPara: null,
      gerando: false,
      pollTimer: null,
      pollInFlight: false,
      requestSeq: 0,
      fullscreen: false,
      podeVerHistorico: podeVerHistoricoRotasOtimizadas(),
      sobrepor: false,
      camadasSobreposicao: { atual: true, otimizada: true },
    };
  },
  computed: {
    wrapperAttrs() {
      return this.fullscreen
        ? { value: true, fullscreen: true, hideOverlay: true, transition: "dialog-bottom-transition" }
        : {};
    },
    wrapperListeners() {
      return this.fullscreen ? { input: (val) => { this.fullscreen = !!val; } } : {};
    },
    tiposOtimizacao() {
      return [
        { value: "unidade", text: this.t('typeUnit') },
        { value: "linha", text: this.t('typeLine') },
      ];
    },
    porLinha() {
      return this.tipoOtimizacao === "linha";
    },
    /** Linhas atuais da unidade, cada uma com a sua cor. */
    linhasUnidade() {
      return ((this.dados && this.dados.atual && this.dados.atual.linhas) || []).map((l, i) => {
        const principais = (l.rotas || []).filter((r) => r.geojson && Number(r.id_tipo_rota) !== TIPO_ROTA_DESLOCAMENTO);
        return {
          ...l,
          cor: cor(i),
          km: principais.reduce((acc, r) => acc + comprimentoGeojson(r.geojson), 0) / 1000,
        };
      });
    },
    /** "Ambos" (-1) não é comparável: o seletor só oferece sentidos reais. */
    sentidosComparaveis() {
      return (this.sentidos || []).filter((s) => Number(s.id_sentido) !== -1);
    },
    idSentido() {
      const atual = toNumber(this.sentidoLocal);
      if (atual != null) return atual;
      const ida = this.sentidosComparaveis.find((s) => Number(s.id_sentido) === SENTIDO_IDA);
      const primeiro = ida || this.sentidosComparaveis[0];
      return primeiro ? Number(primeiro.id_sentido) : SENTIDO_IDA;
    },
    chaveCarga() {
      return this.unidade && this.unidade.id_unidade != null ? `${this.unidade.id_unidade}_${this.idSentido}` : null;
    },
    /** Linhas desenhadas: na comparação linha a linha, só a escolhida na lista. */
    linhasAtuais() {
      if (!this.porLinha || this.idLinhaSelecionada == null) return this.linhasUnidade;
      return this.linhasUnidade.filter((l) => l.id_linha === this.idLinhaSelecionada);
    },
    otimizada() {
      return (this.dados && this.dados.otimizada) || null;
    },
    rotasOtimizadas() {
      const o = this.otimizada;
      return ((o && o.rotas_json) || []).map((r, i) => ({ ...r, cor: cor(i) }));
    },
    nomesLinhas() {
      const map = {};
      this.linhasAtuais.forEach((l) => { map[l.id_linha] = l.cod_linha || l.nome_linha || `#${l.id_linha}`; });
      return map;
    },
    nomesCercas() {
      const map = {};
      this.linhasUnidade.forEach((l) => (l.paradas || []).forEach((p) => { map[p.id_cerca] = p.nome_cerca; }));
      return map;
    },
    paradasDistintas() {
      const set = new Set();
      this.linhasAtuais.forEach((l) => (l.paradas || []).forEach((p) => set.add(p.id_cerca)));
      return set.size;
    },
    centro() {
      const c = this.dados && this.dados.centro;
      const lat = c && toNumber(c.lat);
      const lng = c && toNumber(c.lng);
      if (lat == null || lng == null) return null;
      return { lat, lng, label: `${this.t('unitCenter')}: ${c.nome_cerca || c.descricao_unidade || ''}` };
    },
    resumo() {
      const o = this.otimizada;
      const kmAtual = this.linhasAtuais.reduce((acc, l) => acc + l.km, 0);
      const kmOtimizada = o && o.distancia_total != null ? Number(o.distancia_total) / 1000 : null;
      const limite = o && toNumber(o.tempo_limite_min);
      const duracaoMax = o && toNumber(o.duracao_max);
      const atendidas = this.rotasOtimizadas.reduce((acc, r) => acc + (r.paradas || []).length, 0);
      const infos = [
        {
          label: this.t('linesVsRoutes'),
          valor: `${this.linhasAtuais.length} → ${o && o.qtd_rotas != null ? o.qtd_rotas : '—'}`,
          classe: o && o.qtd_rotas != null && o.qtd_rotas < this.linhasAtuais.length ? 'green--text text--darken-2' : null,
        },
        { label: this.t('kmToday'), valor: kmAtual ? `${kmAtual.toFixed(1)} km` : '—' },
        { label: this.t('kmOptimized'), valor: kmOtimizada != null ? `${kmOtimizada.toFixed(1)} km` : '—' },
        {
          label: this.t('longestRoute'),
          valor: `${this.formataDuracao(duracaoMax)} / ${limite ? `${limite} min` : '—'}`,
        },
        { label: this.t('stopsServed'), valor: o && o.rotas_json ? `${atendidas} / ${this.paradasDistintas}` : '—' },
      ];
      if (o) {
        infos.push({ label: this.t('status'), valor: o.status });
        infos.push({ label: this.t('generatedAt'), valor: o.dt_geracao_extenso || '—' });
      }
      return infos;
    },
    avisos() {
      const o = this.otimizada;
      const out = [];
      if (!this.centro) out.push(this.t('noCenter'));
      if (o && !toNumber(o.tempo_limite_min)) out.push(this.t('noTimeLimit'));
      const semLotacao = this.linhasAtuais.filter((l) => !lotacaoDaLinha(l));
      if (semLotacao.length) {
        out.push(this.t('noCapacity', { linhas: semLotacao.map((l) => l.cod_linha || l.id_linha).join(", ") }));
      }
      const nao = (o && o.nao_atendidas_json) || [];
      if (nao.length) out.push(this.t('unassigned', { count: nao.length }));
      if (o && o.status === 'ERRO' && o.mensagem) out.push(this.mensagemOtimizada(o));
      return out;
    },
    colunas() {
      return [this.colunaAtual(), this.colunaOtimizada()];
    },
    colunasVisiveis() {
      return this.sobrepor && !this.porLinha ? [this.colunaSobreposta()] : this.colunas;
    },
  },
  watch: {
    sentidos: {
      immediate: true,
      handler() {
        if (this.sentidoLocal != null) return;
        const ida = this.sentidosComparaveis.find((s) => Number(s.id_sentido) === SENTIDO_IDA);
        const primeiro = ida || this.sentidosComparaveis[0];
        if (primeiro) this.sentidoLocal = Number(primeiro.id_sentido);
      },
    },
    idLinhaSelecionada() {
      this.ajustaTodos();
    },
    chaveCarga(nova, antiga) {
      // Outra unidade: a geração em andamento era da anterior
      if (nova && antiga && nova.split("_")[0] !== antiga.split("_")[0]) this.paraGeracao();
      this.dados = null;
      this.otimizadasLinha = {};
      this.idLinhaSelecionada = null;
      this.carregadoPara = null;
      if (this.active) this.load();
    },
    tipoOtimizacao() {
      this.dados = null;
      this.otimizadasLinha = {};
      this.carregadoPara = null;
      if (this.active) this.load();
      this.paraGeracao();
    },
    colunasVisiveis(colunas) {
      this.$nextTick(() => colunas.forEach((c) => this.desenhaParadas(c.key)));
    },
    fullscreen() {
      this.ajustaTodos();
    },
    sobrepor() {
      this.ajustaTodos();
    },
    active(val) {
      if (!val) {
        this.fullscreen = false;
        return;
      }
      if (this.carregadoPara !== this.chaveCarga) this.load();
      else this.ajustaTodos();
    },
  },
  created() {
    // Camadas Leaflet das paradas, por coluna: fora do data, não precisam ser reativas.
    this.camadasParadas = {};
    this.filaLinhas = [];
  },
  mounted() {
    if (this.active) this.load();
  },
  beforeDestroy() {
    this.clearPoll();
  },
  methods: {
    cabecalhoTabela(coluna) {
      return coluna.cabecalho.map((text, i) => ({
        text,
        value: i === 0 ? "nome" : `v${i - 1}`,
        sortable: false,
      }));
    },
    linhasTabela(coluna) {
      return coluna.itens.map((item) => {
        const linha = { ...item };
        (item.valores || []).forEach((v, i) => { linha[`v${i}`] = v; });
        return linha;
      });
    },
    t(key, args) {
      return this.$t(`crudUnidades.comparison.${key}`, args);
    },
    abreHistorico() {
      this.fullscreen = false;
      this.$router.push(rotaHistoricoRotasOtimizadas("unidade", this.unidade.id_unidade, this.sentidoLocal));
    },
    formataDuracao(segundos) {
      const s = toNumber(segundos);
      if (s == null) return "—";
      const h = Math.floor(s / 3600);
      const min = Math.round((s % 3600) / 60);
      return h ? `${h} h ${min} min` : `${min} min`;
    },
    /**
     * Mensagem de erro da geração em texto legível; os erros conhecidos do VROOM (limite de
     * localizações, parada longe da malha viária) viram frase, o resto segue como veio.
     */
    mensagemOtimizada(o) {
      const msg = (o && o.mensagem) || "";
      const limite = msg.match(/Too many locations \(\s*(\d+)\s*\).*maximum is set to (\d+)/);
      if (limite) return this.t('tooManyStops', { count: limite[1], max: limite[2] });
      const semRota = msg.match(/Could not find route near location \[\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*\]/);
      if (semRota) return this.t('stopOffRoad', { lat: semRota[2], lng: semRota[1] });
      return msg;
    },
    mapaDaColuna(key) {
      const ref = this.$refs[`map_${key}`];
      const comp = Array.isArray(ref) ? ref[0] : ref;
      return (comp && comp.mapObject) || null;
    },
    onMapaPronto(key) {
      this.desenhaParadas(key);
      this.ajustaMapa(key);
    },
    /**
     * Paradas da coluna como circleMarkers no renderer canvas do mapa (preferCanvas): um
     * componente Vue por parada deixava a aba lenta nas unidades com milhares de paradas.
     */
    desenhaParadas(key) {
      const map = this.mapaDaColuna(key);
      const anterior = this.camadasParadas[key];
      if (anterior && anterior.map.hasLayer(anterior.layer)) anterior.map.removeLayer(anterior.layer);
      delete this.camadasParadas[key];
      const coluna = this.colunasVisiveis.find((c) => c.key === key);
      if (!map || !coluna) return;
      const layer = L.layerGroup(coluna.paradas.map((p) => L.circleMarker([p.lat, p.lng], {
        radius: 5,
        color: p.cor,
        fillColor: "#ffffff",
        fillOpacity: 1,
        weight: 2,
      }).bindTooltip(p.label)));
      layer.addTo(map);
      this.camadasParadas[key] = { map, layer };
    },
    nomeParada(idCerca) {
      return this.nomesCercas[idCerca] || `#${idCerca}`;
    },
    /** Paradas das linhas atuais (uma por cerca, com as linhas que passam nela). */
    paradasAtuais(corUnica) {
      const porCerca = new Map();
      this.linhasAtuais.forEach((l) => {
        (l.paradas || []).forEach((p) => {
          const lat = toNumber(p.lat);
          const lng = toNumber(p.lng);
          if (lat == null || lng == null) return;
          const atual = porCerca.get(p.id_cerca);
          if (atual) atual.linhas.push(l.cod_linha);
          else porCerca.set(p.id_cerca, { key: p.id_cerca, id_cerca: p.id_cerca, lat, lng, cor: corUnica || l.cor, linhas: [l.cod_linha] });
        });
      });
      return [...porCerca.values()].map((p) => ({
        ...p,
        label: `${this.nomeParada(p.id_cerca)} · ${this.t('lines')}: ${p.linhas.join(", ")}`,
      }));
    },
    colunaAtual() {
      const linhas = this.linhasAtuais;
      const geojsons = [];
      linhas.forEach((l) => {
        (l.rotas || []).filter((r) => r.geojson).forEach((r) => {
          geojsons.push({
            id: `atual_${l.id_linha}_${r.id_rota}`,
            geojson: r.geojson,
            style: () => ({
              color: l.cor,
              weight: 4,
              dashArray: Number(r.id_tipo_rota) === TIPO_ROTA_DESLOCAMENTO ? "6 6" : null,
            }),
          });
        });
      });
      return {
        key: "atual",
        titulo: this.t('today'),
        geojsons,
        paradas: this.paradasAtuais(),
        vazio: this.dados && !linhas.length ? this.t('noLines') : null,
        cabecalho: [this.t('line'), this.t('distance'), this.t('stops'), this.t('passengersCapacity')],
        itens: (this.porLinha ? this.linhasUnidade : linhas).map((l) => ({
          key: l.id_linha,
          id_linha: l.id_linha,
          cor: l.cor,
          nome: [l.cod_linha, l.nome_linha].filter(Boolean).join(" — "),
          valores: [
            l.km ? `${l.km.toFixed(1)} km` : "—",
            (l.paradas || []).length,
            `${l.demanda || 0} / ${lotacaoDaLinha(l) || "—"}${l.lotacao_maxima && l.turno_lotacao_maxima ? ` (${l.turno_lotacao_maxima})` : ""}`,
          ],
        })),
      };
    },
    /** Linha a linha: o desenho da rota otimizada de cada linha, na cor da linha. */
    colunaOtimizadaPorLinha() {
      const itens = [];
      const geojsons = [];
      const paradas = [];
      const visiveis = new Set(this.linhasAtuais.map((l) => l.id_linha));
      this.linhasUnidade.forEach((l) => {
        const o = this.otimizadasLinha[l.id_linha];
        if (!o || !o.geojson) return;
        if (visiveis.has(l.id_linha)) geojsons.push({
          id: `otimizada_linha_${l.id_linha}`,
          geojson: o.geojson,
          style: () => ({ color: l.cor, weight: 5 }),
        });
        if (visiveis.has(l.id_linha)) (o.paradas_json || []).forEach((p) => {
          paradas.push({
            key: `${l.id_linha}_${p.id_cerca}`,
            lat: toNumber(p.lat),
            lng: toNumber(p.lng),
            cor: l.cor,
            label: `${l.cod_linha || l.id_linha}.${p.ordem_otimizada != null ? p.ordem_otimizada : ''} ${this.nomeParada(p.id_cerca)}`,
          });
        });
        itens.push({
          key: l.id_linha,
          id_linha: l.id_linha,
          cor: l.cor,
          nome: [l.cod_linha, l.nome_linha].filter(Boolean).join(" — "),
          valores: [
            `${((toNumber(o.distancia) || 0) / 1000).toFixed(1)} km`,
            this.formataDuracao(o.duracao),
            o.qtd_paradas != null ? o.qtd_paradas : (o.paradas_json || []).length,
          ],
        });
      });
      let vazio = null;
      if (this.dados && !this.loadingRotas && !geojsons.length) vazio = this.t('noOptimizedLines');
      return {
        key: "otimizada",
        titulo: this.t('optimized'),
        geojsons,
        paradas: paradas.filter((p) => p.lat != null && p.lng != null),
        vazio,
        cabecalho: [this.t('line'), this.t('distance'), this.t('duration'), this.t('stops')],
        itens,
      };
    },
    colunaOtimizada() {
      if (this.porLinha) return this.colunaOtimizadaPorLinha();
      const o = this.otimizada;
      const rotas = this.rotasOtimizadas;
      const limite = o && toNumber(o.tempo_limite_min);
      const paradas = [];
      rotas.forEach((r, i) => {
        (r.paradas || []).forEach((p) => {
          paradas.push({
            key: `${i}_${p.id_cerca}`,
            lat: toNumber(p.lat),
            lng: toNumber(p.lng),
            cor: r.cor,
            label: `${i + 1}${r.cod_turno ? ` (${r.cod_turno})` : ""}.${p.ordem} ${this.nomeParada(p.id_cerca)} · ${this.t('passengers')}: ${p.demanda || 0}`
              + ` · ${this.t('originLines')}: ${(p.linhas_origem || []).map((id) => this.nomesLinhas[id] || id).join(", ")}`,
          });
        });
      });
      paradas.push(...this.naoAtendidasMarcadores());
      let vazio = null;
      if (this.dados && !o) vazio = this.t('noOptimized');
      else if (o && o.status === "PENDENTE") vazio = this.t('pending');
      else if (o && !rotas.length) vazio = this.mensagemOtimizada(o) || o.status;
      return {
        key: "otimizada",
        titulo: this.t('optimized'),
        geojsons: rotas.filter((r) => r.geojson).map((r, i) => ({
          id: `otimizada_${i}`,
          geojson: r.geojson,
          style: () => ({ color: r.cor, weight: 5 }),
        })),
        paradas: paradas.filter((p) => p.lat != null && p.lng != null),
        vazio,
        cabecalho: [this.t('route'), this.t('distance'), this.t('duration'), this.t('stops'), this.t('loadCapacity')],
        itens: rotas.map((r, i) => {
          const duracao = toNumber(r.duracao);
          return {
            key: i,
            cor: r.cor,
            nome: `${this.t('route')} ${i + 1}${r.cod_turno ? ` · ${r.cod_turno}` : ""}`,
            valores: [
              `${((toNumber(r.distancia) || 0) / 1000).toFixed(1)} km`,
              this.formataDuracao(duracao),
              (r.paradas || []).length,
              `${r.carga || 0} / ${toNumber(r.capacidade) || "—"}`,
            ],
            classes: [null, limite && duracao > limite * 60 ? "red--text" : null, null, null],
          };
        }),
      };
    },
    naoAtendidasMarcadores() {
      const o = this.otimizada;
      const coords = new Map();
      this.paradasAtuais().forEach((p) => coords.set(p.id_cerca, p));
      return ((o && o.nao_atendidas_json) || [])
        .map((n) => {
          const p = coords.get(n.id_cerca);
          if (!p) return null;
          return {
            key: `nao_${n.id_cerca}`,
            lat: p.lat,
            lng: p.lng,
            cor: COR_NAO_ATENDIDA,
            label: `${this.nomeParada(n.id_cerca)} · ${this.t('unassignedStop')}`,
          };
        })
        .filter(Boolean);
    },
    /** Linhas atuais tracejadas por cima das rotas consolidadas (faixas largas e translúcidas). */
    colunaSobreposta() {
      const atual = this.colunaAtual();
      const otimizada = this.colunaOtimizada();
      const visivel = this.camadasSobreposicao;
      const geojsons = [
        ...(visivel.otimizada
          ? this.rotasOtimizadas.filter((r) => r.geojson).map((r, i) => ({
              id: `sob_otimizada_${i}`,
              geojson: r.geojson,
              style: () => ({ color: r.cor, weight: 12, opacity: 0.45, lineCap: "round", lineJoin: "round" }),
            }))
          : []),
        ...(visivel.atual
          ? atual.geojsons.map((g) => ({
              ...g,
              id: `sob_${g.id}`,
              style: () => ({ ...g.style(), weight: 3, dashArray: "6 6" }),
            }))
          : []),
      ];
      return {
        key: "sobreposta",
        titulo: this.t('overlayTitle'),
        camadas: [
          { camada: "atual", titulo: this.t('today') },
          { camada: "otimizada", titulo: this.t('optimized') },
        ],
        geojsons,
        paradas: [
          ...this.paradasAtuais(COR_PARADA),
          ...this.naoAtendidasMarcadores(),
        ],
        vazio: [atual.vazio, otimizada.vazio].filter(Boolean).join(" · ") || null,
        cabecalho: otimizada.cabecalho,
        itens: otimizada.itens,
      };
    },
    /** Linha a linha: clicar numa linha da tabela filtra os mapas; clicar de novo mostra todas. */
    selecionaLinhaTabela(item) {
      if (!this.porLinha || !item || item.id_linha == null) return;
      this.idLinhaSelecionada = this.idLinhaSelecionada === item.id_linha ? null : item.id_linha;
    },
    itemClasseTabela(item) {
      if (!this.porLinha) return "";
      return item.id_linha === this.idLinhaSelecionada ? "unidade-comparacao-rotas__linha--ativa" : "unidade-comparacao-rotas__linha";
    },
    nomeLinha(l) {
      return [l.cod_linha, l.nome_linha].filter(Boolean).join(" — ") || `#${l.id_linha}`;
    },
    async load() {
      if (!this.chaveCarga) return;
      const chave = this.chaveCarga;
      const seq = ++this.requestSeq;
      this.loading = true;
      const chamar = (extra) => apiController.request(apiController.endpoints.getComparacaorotasunidade, {
        data: { id_unidade: this.unidade.id_unidade, id_sentido: this.idSentido, ...extra },
        silent: true,
      });
      const obsoleta = () => seq !== this.requestSeq;
      try {
        // Em partes: cada requisição fica curta e não estoura o timeout do gateway
        const [otimizada, atual] = await Promise.all([
          chamar({ parte: "otimizada" }),
          chamar({ parte: "atual" }),
        ]);
        // Resposta de uma unidade/sentido que o usuário já deixou para trás
        if (obsoleta()) return;
        this.dados = { ...(otimizada.data || {}), atual: (atual.data && atual.data.atual) || { linhas: [] } };
        this.carregadoPara = chave;
        this.ajustaTodos();
        this.loading = false;
        await this.carregaRotasAtuais(chamar, obsoleta);
        if (this.porLinha && !obsoleta()) await this.carregaOtimizadasLinhas(chamar, obsoleta);
      } catch (e) {
        if (obsoleta()) return;
        this.dados = null;
        EventBus.$emit("show-error", { error: e });
      } finally {
        if (!obsoleta()) {
          this.loading = false;
          this.loadingRotas = false;
        }
      }
    },
    /** Rotas (geojson) das linhas atuais em lotes pequenos, desenhadas à medida que chegam. */
    async carregaRotasAtuais(chamar, obsoleta) {
      const linhas = this.dados.atual.linhas;
      const lotes = [];
      for (let i = 0; i < linhas.length; i += LINHAS_POR_LOTE_ROTAS) {
        lotes.push(linhas.slice(i, i + LINHAS_POR_LOTE_ROTAS).map((l) => l.id_linha));
      }
      this.loadingRotas = lotes.length > 0;
      let proximo = 0;
      const trabalhador = async () => {
        while (proximo < lotes.length && !obsoleta()) {
          const ids = lotes[proximo++];
          const res = await chamar({ parte: "rotas", id_linhas: ids });
          if (obsoleta()) return;
          const porLinha = {};
          ((res.data && res.data.rotas) || []).forEach((r) => (porLinha[r.id_linha] = porLinha[r.id_linha] || []).push(r));
          ids.forEach((id) => {
            const l = this.dados.atual.linhas.find((x) => x.id_linha === id);
            if (l) this.$set(l, "rotas", porLinha[id] || []);
          });
        }
      };
      await Promise.all(Array.from({ length: Math.min(2, lotes.length) }, trabalhador));
      if (obsoleta()) return;
      this.ajustaTodos();
    },
    /** Rotas otimizadas de cada linha da unidade, em lotes pequenos. */
    async carregaOtimizadasLinhas(chamar, obsoleta) {
      const ids = this.linhasUnidade.map((l) => l.id_linha);
      this.loadingRotas = ids.length > 0;
      const porId = {};
      for (let i = 0; i < ids.length && !obsoleta(); i += LINHAS_POR_LOTE_ROTAS) {
        const res = await chamar({ parte: "otimizadas_linhas", id_linhas: ids.slice(i, i + LINHAS_POR_LOTE_ROTAS) });
        if (obsoleta()) return;
        ((res.data && res.data.otimizadas) || []).forEach((o) => { porId[o.id_linha] = o; });
        this.otimizadasLinha = { ...porId };
      }
      if (obsoleta()) return;
      this.loadingRotas = false;
      this.ajustaTodos();
    },
    ajustaTodos() {
      this.$nextTick(() => {
        // O v-tab-item anima a entrada: espera o painel ter tamanho antes de medir
        setTimeout(() => this.colunasVisiveis.forEach((c) => this.ajustaMapa(c.key)), 250);
      });
    },
    ajustaMapa(key) {
      const map = this.mapaDaColuna(key);
      if (!map) return;
      map.invalidateSize();
      const coluna = this.colunasVisiveis.find((c) => c.key === key);
      if (!coluna) return;
      const bounds = L.latLngBounds([]);
      coluna.paradas.forEach((p) => bounds.extend([p.lat, p.lng]));
      if (this.centro) bounds.extend([this.centro.lat, this.centro.lng]);
      coluna.geojsons.forEach((g) => {
        try {
          const b = L.geoJSON(g.geojson).getBounds();
          if (b.isValid()) bounds.extend(b);
        } catch (_) {
          /* geojson inválido: ignora no enquadramento */
        }
      });
      if (bounds.isValid()) map.fitBounds(bounds, { padding: [20, 20] });
    },
    clearPoll() {
      if (this.pollTimer != null) clearInterval(this.pollTimer);
      this.pollTimer = null;
      this.pollInFlight = false;
    },
    paraGeracao() {
      this.clearPoll();
      this.filaLinhas = [];
      this.gerando = false;
    },
    falhaGeracao(msg) {
      this.paraGeracao();
      EventBus.$emit("show-alert", { mensagem: msg || this.t('generateError'), tipo: "error" });
    },
    /**
     * O scheduler grava em `mensagem_scheduler` uma chave técnica (ex.: MSG_BLOQUEIO_ALLOWLIST);
     * aqui ela vira um texto que diz o que fazer. Mesmo padrão de LinhaComparacaoRotas.
     */
    mensagemFalhaScheduler(processo) {
      const chave = processo && processo.mensagem_scheduler;
      if (chave === "MSG_BLOQUEIO_ALLOWLIST") return this.t('generateBlocked');
      if (chave === "MSG_INTERRUPCAO_SIGTERM" || chave === "MSG_INTERRUPCAO_SIGTERM_FALHOU") {
        return this.t('generateInterrupted');
      }
      return this.t('generateError');
    },
    /** Linha a linha: gera a otimização da linha filtrada, ou de cada linha da unidade, uma por vez. */
    async gerarOtimizacaoLinhas() {
      this.filaLinhas = this.idLinhaSelecionada != null
        ? [this.idLinhaSelecionada]
        : this.linhasUnidade.map((l) => l.id_linha);
      if (!this.filaLinhas.length) return;
      this.gerando = true;
      this.geraProximaLinha();
    },
    async geraProximaLinha() {
      if (!this.gerando) return;
      if (!this.filaLinhas.length) {
        this.paraGeracao();
        EventBus.$emit("show-alert", { mensagem: this.t('generated'), tipo: "success" });
        this.load();
        return;
      }
      const idLinha = this.filaLinhas.shift();
      let idProcesso = null;
      try {
        const res = await apiController.request(apiController.endpoints.geraRotaotimizadalinha, {
          data: { id_linha: idLinha },
          silent: true,
        });
        idProcesso = res.data && res.data.id_processo;
      } catch (e) {
        const data = e.response && e.response.data;
        return this.falhaGeracao(data && (data.message || data.mensagem));
      }
      if (!idProcesso) return this.falhaGeracao();
      this.pollProcesso(idProcesso, () => this.geraProximaLinha());
    },
    async gerarOtimizacao() {
      if (!this.unidade || this.unidade.id_unidade == null || this.gerando) return;
      if (this.porLinha) return this.gerarOtimizacaoLinhas();
      this.gerando = true;
      let idProcesso = null;
      try {
        const res = await apiController.request(apiController.endpoints.geraRotaotimizadaunidade, {
          data: { id_unidade: this.unidade.id_unidade },
          silent: true,
        });
        idProcesso = res.data && res.data.id_processo;
      } catch (e) {
        const data = e.response && e.response.data;
        return this.falhaGeracao(data && (data.message || data.mensagem));
      }
      if (!idProcesso) return this.falhaGeracao();
      this.pollProcesso(idProcesso);
    },
    pollProcesso(idProcesso, aoConcluir) {
      this.clearPoll();
      const deadline = Date.now() + POLL_TIMEOUT_MS;
      const pendingDeadline = Date.now() + PENDING_TIMEOUT_MS;
      const pollOnce = () => {
        if (!this.gerando) return;
        if (Date.now() > deadline) return this.falhaGeracao(this.t('generateTimeout'));
        if (this.pollInFlight) return;
        this.pollInFlight = true;
        apiController.request(apiController.endpoints.schedulerGetProcessoschedulerbyid, {
          data: { id_processo: idProcesso },
          config: { timeout: 30000 },
          silent: true,
          onSuccess: (statusRes) => {
            this.pollInFlight = false;
            if (!this.gerando) return;
            const pollData = statusRes.data || {};
            if (pollData.erro) return this.falhaGeracao(pollData.mensagem);
            const processo = pollData.processo || {};
            if (processo.status === "PENDING") {
              if (Date.now() > pendingDeadline) this.falhaGeracao(this.t('generateNotStarted'));
              return;
            }
            if (processo.status === "EXECUTING") return;
            if (processo.status !== "DONE") return this.falhaGeracao(this.mensagemFalhaScheduler(processo));
            if (aoConcluir) {
              this.clearPoll();
              aoConcluir();
              return;
            }
            this.paraGeracao();
            EventBus.$emit("show-alert", { mensagem: this.t('generated'), tipo: "success" });
            this.load();
          },
          onError: (e) => {
            const data = e.response && e.response.data;
            this.falhaGeracao((data && (data.message || data.mensagem)) || e.message);
          },
        });
      };
      this.pollTimer = setInterval(pollOnce, POLL_MS);
      pollOnce();
    },
  },
};
</script>

<style scoped>
.unidade-comparacao-rotas__lista {
  max-height: 75vh;
  overflow-y: auto;
}
.unidade-comparacao-rotas__swatch {
  display: inline-block;
  width: 14px;
  height: 4px;
  border-radius: 2px;
  vertical-align: middle;
}
/* Contexto de empilhamento próprio: os panes do Leaflet e os avisos sobre o mapa (z-index até
   1000) ficam presos aqui e não passam por cima de diálogos e menus da tela. */
.unidade-comparacao-rotas__map {
  position: relative;
  z-index: 0;
  isolation: isolate;
  height: 420px;
  flex-grow: 1;
}
.unidade-comparacao-rotas__map--sobreposto {
  height: 600px;
}
.unidade-comparacao-rotas__map--sobreposto >>> .leaflet-tile-pane {
  filter: grayscale(1) brightness(1.05) contrast(0.85);
}
.unidade-comparacao-rotas__sentido {
  max-width: 260px;
}
.unidade-comparacao-rotas--fullscreen {
  min-height: 100%;
}
.unidade-comparacao-rotas--fullscreen .unidade-comparacao-rotas__map {
  height: calc(100vh - 330px);
  min-height: 320px;
}
.unidade-comparacao-rotas__indicador {
  padding-top: 0 !important;
  padding-bottom: 2px !important;
}
.unidade-comparacao-rotas__indicador .title {
  line-height: 1.3;
}
.unidade-comparacao-rotas__indicador + .unidade-comparacao-rotas__indicador {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
.unidade-comparacao-rotas__tabela >>> .unidade-comparacao-rotas__linha {
  cursor: pointer;
}
.unidade-comparacao-rotas__tabela >>> .unidade-comparacao-rotas__linha--ativa {
  cursor: pointer;
  background: rgba(25, 118, 210, 0.12);
}
.unidade-comparacao-rotas__tabela {
  font-size: 12px;
}
.unidade-comparacao-rotas__legenda {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 500;
  background: rgba(255, 255, 255, 0.95) !important;
}
.unidade-comparacao-rotas__vazio {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  padding: 8px 16px;
  border-radius: 8px;
  background: var(--v-background-base, #fff);
  max-width: 90%;
  text-align: center;
}
</style>
